<div *ngIf="dataReceived" class="container">
    <!-- testing external Push -->
    <h1>ELearning Dashboard</h1>
    <div *ngIf="isAdmin" class="teacherFilter">
        <app-teacher-search-autofill
        [teachers]="getTeachers()"
        [teacherid]="state.TeacherID"
        (teacher)="filterTeacher($event)"
        >
        </app-teacher-search-autofill>
    </div>
    <div class="filterAndMainSection">
        <div class="filterSection">
            
            <button mat-stroked-button *ngIf="ifTeacherAndHaveClasses" (click)="openClassFilterMgmtDlg()" class="showHide">Show or Hide Classes</button>

            <hr *ngIf="!isAdmin && teacherHasStudents">

            <div class="filterStudent" *ngIf="ifTeacherOrSelectedTeacher">
                <app-student-filter
                ></app-student-filter>
            </div> 

            <hr *ngIf="ifTeacherOrSelectedTeacher">
            
            <div class="expand-collapse-all" *ngIf="ifTeacherOrSelectedTeacher">
              
                <app-collapse-expand-all-classes></app-collapse-expand-all-classes>
            </div>
            <div *ngIf="isAdmin" class="hiddenStuff">

            </div>
    
        </div> 
    
        <div class="mainSection">
            <div class="classCards">
                <div *ngFor="let class of populateClasses" class="classCard" >
                     <app-elearningdash-class-view
                     [classData]="class"
                     >
                     </app-elearningdash-class-view>
                </div>
    
                <div class="responses">
                    <div *ngIf="ifNoTeachersAvailable">There are currently no teachers available.</div>
                    <div *ngIf="ifTeacherHasNoClasses">{{selectedTeacher.value}} currently has no classes.</div>
                    <div *ngIf="ifNoTeacherSelected">No teacher selected. Make a teacher selection.</div>
                    <div *ngIf="ifTeacherNoClassesToDisplay">You have no classes to display.</div>
                    <div *ngIf="ifAllClassesHidden">All available classes are hidden. <br>Use the "Show or Hide Classes" button to show or hide classes.</div>
                </div>
                
    
            </div>
        
            <div class="commonLinks">
                <span>ELearning Links</span>
                <a  mat-stroked-button color="primary" href="/LessonProgress/LessonProgress.aspx">Student Progress</a>
                <a  mat-stroked-button color="primary" href="/RTIModules/RTISearch.aspx">RTI Lessons</a>
                <a  mat-stroked-button color="primary" href="/Reports/StudentReports.aspx">Reports</a>
                <a  mat-stroked-button color="primary" href="/CurriculumPlanner/CurriculumPlanner.aspx">Curriculum Planner</a>
                <a  mat-stroked-button color="primary" href="/LearningContent/LibrarySearch.aspx">Library Search</a>
                <a  mat-stroked-button color="primary" href="/ILPAutoAssign/ILPAutoAssign.aspx">Auto Assign Lessons</a>
                <a mat-stroked-button color="primary" [routerLink]="['/ELearning/Class']">Gradebook</a>
            </div>
        </div>
    </div>
    
    
</div>
